// @flow

export const SEND_MESSAGE: 'MESSAGE.SEND' = 'MESSAGE.SEND';

